<template>
  <span>
    <v-row>
      <v-col
        :style="{
          font: `normal normal 600 ${
            $vuetify.breakpoint.lgAndUp ? '26px' : '19px'
          } Poppins`,
          color: '#000B8D',
          minHeight: '36px'
        }"
        ><div>{{ form.title }}</div></v-col
      >
    </v-row>

    <v-row>
      <v-col
        :style="{
          font: 'normal normal normal 16px/19px Lato',
          color: '#333333'
        }"
        >{{ form.subTitle }}</v-col
      >
    </v-row>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FormHeader",

  props: ["form"]
};
</script>
